import React, { useState } from 'react';

import { contractsData } from '../../ContractsPage/data';
import SvgIcon from "../../SharedComponents/Icons";

import './index.sass';
import ContractsFeaturesComparisonModal from "../ContractsFeaturesComparisonModal";


const AccountInfo = ({ accountType, paymentType }) => {

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const currentContract = contractsData[accountType];
  const { name, prices } = currentContract;
  const { discountPrice, price, undiscountedPrice } = prices[paymentType];


  return (
    <div className="account-info">
      <div className="account-info__main-content">
        <div className="account-info__img-wrapper">
          <SvgIcon name={`${accountType}_account`} width={110} height={64} />
        </div>

        <div className="account-info__info-content">
          <h2 className="account-info__headline">
            { name }
          </h2>

          <div className="account-info__price-wrapper">

            <div className="account-info__price">
              { discountPrice &&
                <div className="account-info__price-discount">
                  { discountPrice }
                </div>
              }
              { price }
            </div>

            { undiscountedPrice &&
              <div className="account-info__price-undiscounted">
                { undiscountedPrice }
              </div>
            }
          </div>
        </div>
      </div>

      <div className="account-info__comparison-modal-trigger" onClick={() => setModalIsOpen(true)}>
        <SvgIcon name="compare" width={16} height={16} />
        Sammenlign priser
      </div>

      <ContractsFeaturesComparisonModal
        handleClose={() => setModalIsOpen(false)}
        paymentType={paymentType}
        showModal={modalIsOpen}
      />

    </div>
  )
}

export default AccountInfo;
